// OWNER: AREA-TEMPLATES
// Layout for one template: supplies its breadcrumb (the template's name).
import { createFileRoute, Outlet } from '@tanstack/react-router'
import { TemplateCrumb } from '@/features/templates/bits'

export const Route = createFileRoute('/templates/$templateId')({
  staticData: { crumb: TemplateCrumb },
  component: Outlet,
})
